import { IApplicationError } from '../shared/application-error';

export interface RegistrationTokenValidationModel {
    tokenValue: string;
    hasPassword: boolean;
    tokenValidationErrorType: number;
    locale: string;
    applicationError: IApplicationError;
    participantName: string;
    languageId?: number;
    otac: string;
    participantIdentifier: string;
}
